module.exports = __webpack_public_path__ + "static/media/classTwo.a6ebee97.jpg";